import axios from 'axios';

import type {
  IUserOrgCountRequest,
  IUserOrgCountQuery,
  IUserOrgCountResponse,
} from '@/app-package';

const orgCount = async (params?: IUserOrgCountQuery) => {
  const config: IUserOrgCountRequest = {
    url: '/user/org/count',
    method: 'get',
    params,
  };

  const { data } = await axios.request<IUserOrgCountResponse>(config);

  return data;
};

export default orgCount;
